<div class="header bg-white shadow-xl shadow-gray-100">
  <div class="logo">
    <ng-icon class="logo-icon" name="my-history-logo"></ng-icon>
  </div>

  <div class="right-side">
    <div class="apps">
      <ng-icon class="ios" name="download-app-store"></ng-icon>
      <ng-icon class="android" name="download-app-android"></ng-icon>
    </div>
    <button type="button" class="create-account button button-primary mt-9 mb-9" (click)="onCreateAccount()" mat-flat-button>Create Account</button>
  </div>
</div>

<ng-content></ng-content>
